'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _pure = require('revenge/lib/decorators/pure');

var _pure2 = _interopRequireDefault(_pure);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _pure2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-datepicker/lib/utils/pure.js
 ** module id = 552
 ** module chunks = 0
 **/